import { connect } from "react-redux";
import ToggleFilterPanel from "components/molecules/ToggleFilterPanel";
import { filterChange } from "actions";
import { LEHRERINNEN_TOGGLE, DIGITAL_TOGGLE } from "constants/filter";

const mapStateToProps = (state) => {
  const zielgruppeFilter = state.filters[
    LEHRERINNEN_TOGGLE.FILTER_INPUT_NAME
  ].data?.find((filter) => filter.value == LEHRERINNEN_TOGGLE.VALUE);
  const digitalFilter = state.filters[
    DIGITAL_TOGGLE.FILTER_INPUT_NAME
  ].data?.find((filter) => filter.value == DIGITAL_TOGGLE.VALUE);
  return {
    lehrerInnenTotalCount: zielgruppeFilter ? zielgruppeFilter.count : 0,
    lehrerInnenFilter: state.filters[
      LEHRERINNEN_TOGGLE.FILTER_INPUT_NAME
    ].values.includes(LEHRERINNEN_TOGGLE.VALUE),
    digitalTotalCount: digitalFilter ? digitalFilter.count : 0,
    digitalFilter: state.filters[
      DIGITAL_TOGGLE.FILTER_INPUT_NAME
    ].values.includes(DIGITAL_TOGGLE.VALUE),
    totalCount: state.result.totalCount,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFilterToggleChange: (name, value) => {
      dispatch(filterChange(name, value));
    },
  };
};

const ToggleFilterPanelContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ToggleFilterPanel);

export default ToggleFilterPanelContainer;
